const EN = {
    sunday: 'S',
    monday: 'M',
    tuesday: 'T',
    wednesday: 'W',
    thursday: 'T',
    friday: 'F',
    saturday: 'S',
    ok: 'Accept',
    yesterday: 'Yesterday',
    today: 'Today',
    last7Days: 'Last 7 days',
    thisMonth: 'This month',
};

export default EN;
